import React, { useEffect, useState } from 'react';
import { IonButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard, IonCardContent, IonCardHeader, IonCardTitle } from '@ionic/react';

const DirectFetch: React.FC = () => {
  const [result, setResult] = useState<string>('');

  const testDirectFetch = async () => {
    setResult('Iniciando petición directa...');
    
    try {
      // Datos para la petición
      const formData = new FormData();
      formData.append('qr', 'test-qr-code');
      formData.append('userid', 'test-user-id');
      formData.append('userced', 'test-user-ced');
      formData.append('eventcode', 'test-event-code');
      
      // URL del endpoint
      const url = 'https://esimposio.com/miesimposio/app_login/asistencia/';
      
      setResult(prev => prev + '\nEnviando petición POST a: ' + url);
      
      // Realizar la petición con fetch
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      });
      
      setResult(prev => prev + '\nRespuesta recibida: ' + response.status + ' ' + response.statusText);
      
      if (response.ok) {
        const data = await response.json();
        setResult(prev => prev + '\nDatos recibidos: ' + JSON.stringify(data));
      } else {
        setResult(prev => prev + '\nError en la respuesta: ' + response.status + ' ' + response.statusText);
      }
    } catch (error) {
      setResult(prev => prev + '\nError en la petición: ' + JSON.stringify(error));
    }
  };

  // Ejecutar la petición automáticamente al cargar el componente
  useEffect(() => {
    testDirectFetch();
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Direct Fetch Test</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>Resultado de la petición directa</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {result}
            </pre>
            <IonButton expand="block" onClick={testDirectFetch}>Probar de nuevo</IonButton>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default DirectFetch;
